import React from "react";
import { Logo } from "../Logo";
export function Footer() {
  return <footer className="bg-navy-800 px-4 pb-28 pt-12 text-center" data-id="element-147" data-mp="207kryp4zaue2">
      <div className="mx-auto max-w-3xl" data-id="element-148" data-mp="207azmuwgob57">
        <Logo tone="light" data-id="element-149" data-mp="2f4jsxu5brozk" />
        <p className="mt-4 text-sm text-white/70" data-id="element-150" data-mp="2f3sbroch5tst">Rhinoplasty Master Planner™ · Created by Ethan Whitmore</p>
        <p className="mt-1 text-sm text-white/70" data-id="element-151" data-mp="2a71tqvh40o4r">© 2026 Rhinoplasty Lab™. All rights reserved.</p>
        <p className="mt-6 text-xs leading-relaxed text-white/55" data-id="element-152" data-mp="1mgxtmy34r6ii">
          Educational disclaimer: This digital product is intended for qualified medical professionals and educational purposes. It does not constitute medical advice, surgical training, patient-specific recommendations or a substitute for professional education, clinical judgment, applicable regulations, institutional protocols or manufacturer instructions.
        </p>
      </div>
    </footer>;
}